import { BASE_ENV } from './_base';

export const environment = BASE_ENV;
